export default {
    homeScreen : {
        startConversation: 'ابدأ محادثة',
        newConversationButton: 'محادثة جديدة',
        newMessageButton: '+ رسالة جديدة',
        allTopics: 'All topics',
        allChatsButton: 'إظهار الكل',
        poweredBy: 'مدعم من قبل Richpanel',
        reOpenConversation: 'إعادة فتح المحادثة',
        recentConversations: 'محادثاتك',
        startAChat: 'ابدأ دردشة',
        noRecentConversations: 'لا توجد محادثات حديثة',
        noRecentOrders: 'لا يوجد طلبات حديثة',
        haveAQuestion: "هل لديك سؤال؟ أوتريد فقط أن تلقى التحية؟ نحن نتطلع للحصول على ردك؟",
        conversationClosed: `تم إغلاق هذه المحادثة إذا كان لديك أى أستفسار بخصوص هذا الشأن قم بإعادة فتح المحادثة.`,
        retry: 'حاول مرة أخرى',
        errorOccured: 'لقد حدث خطأ أثناء تنفيذ طلبك',
        successMessage: 'لقد تسلمنا طلبك وسيتواصل معك فريقنا عبر البريد الإلكترونى {email} فى أقرب وقت',
        loadingMessage: 'من فضلك انتظر ، نقوم بإرسال طلبك.',
        goHome: 'تم',
        sendUsMessage: 'أرسل لنا رسالة',
        endChat: 'نهاية المحادثة',
	goto: 'اذهب إلى'
    },

    orderStatuses: {
        'completed': 'Completed',
        'pending': 'Pending',
        'on hold': 'On hold',
        'processing': 'Processing',
        'cancelled': 'Cancelled',
        'fulfilled': 'Fulfilled',
        'confirmed': 'Confirmed',
    },

    loginScreen: {
        title: 'الوصول إلى حسابك',
        titleForOrdersScreenForward: 'تسجيل الدخول إلى مركز المساعدة',
        userIdFieldTitle: "البريد الإلكترونى أو رقم التليفون",
        userIdFieldPlaceHolder: "قم بإدخال البريد الإلكترونى أو رقم التليفون",
        sendCode: "أدخل",
        enterCode: 'قم بإدخال الكود الذى أرسلناه',
        enterTheCode: 'قم بإدخال الكود',
        notYourUserId: 'ليس اسم المستخدم الخاص بك {userIdType}؟',
        userIdTypes: {
            'phone': 'الرقم',
            'email': 'البريد الإلكترونى',
        },
        change: 'تغيير',
        notReceivedCode: "فى حالة عدم إستلامك للكود؟",
        resendCode: 'إرسال مرة أخرى',
        in: 'in',
        verifyCode: 'تأكييد',
        logout: 'تسجيل الخروج',
        orderNumberFieldTitle: 'رقم طلبك',
        orderNumberFieldPlaceholder: 'ادخل رقم الطلب مثل: 1234',
        zipcodeFieldTitle: 'الرمز السري للشحن الخاص بك',
        zipcodeFieldPlaceholder: 'ادخل الرمز السري للشحن الخاص بك',
        emailFieldTitle: 'البريد الإلكترونى',
        emailFieldPlaceholder: 'قم بإدخال البريد الإلكترونى',
    },

    orderList : {
        reorder: 'إعادة الطلب',
        getHelp: 'احصل على مساعدة',
        startNewConversation: '+رسالة جديدة',
        viewPreviousOrder:'إظهار جميع الطلبات',
        seeAll: 'إظهار الكل',
        viewMoreOrders: 'إظهار المزيد من الطلبات',
        viewOrderStatus: 'إظهار حالة الطلب',
        chatWithUs: 'ابدأ معنا الدردشة',
        issueWithPreviousOrder:'المساعدة فى طلب سابق' ,
        orderLabel: 'طلب',
        help: 'المساعدة',
        lastOrder: 'الطلب الأخير',
        selectRelevantItems: 'اختيار عناصر ذات صلة',
        selectItemsErrorMsg: 'من فضلك قم بتحديد العناصر للمتابعة',
        selectAll: 'تحديد الكل',
        selectQuantity: 'كم عدد العناصر؟',
        helpWithThisOrder: 'المساعدة فى هذا الطلب',
        yourOrders: 'طلباتك',
        view: 'عرض',
        track: 'تتبع',
        addressTitle: 'ملخص الطلب',
        billingAddressTitle: 'إظهار جميع الطلبات',
        shippingAddressTitle: 'عنوان الشحن',
        receiptTitle: 'العناصر',
        itemTotal: 'إجمالى العناصر',
        taxes: 'الضرائب',
        discounts: 'خصم', 
        giftCard: 'بطاقات الهدايا', 
        deliveryCharges: 'رسوم التوصيل',
        total: 'الإجمالى',
        loginToViewOrders: 'عميل حالي؟',
        loginSuggestion: "الحصول على مساعدة عاجلة & دعم الطلب",
        trackingOrderLabel: 'تتبع الطلب',
        shipmentDescription: "قم بالعودة لهذه الصفحة لمعرفة التحديثات حول حالة الشحن الخاصة بطلبك",
        free: "مجاناً",
        selectedItems: "العناصر المختارة",
        items: "العناصر",
        "orderSearchPlaceholder": '# تصفية حسب الطلب رقم',
        "noOrderFound": 'لا توجد طلبات مطابقة لـ {orderId}',
    },
    chatListScreen: {
        header: 'محادثاتك',
    },
    sentences: {
        "IN_A_DAY" : "يقوم الفريق عادة بالرد خلال يوم.",
        "IN_FEW_MINUTES": "يقوم الفريق عادة بالرد خلال دقائق.",
        "IN_FEW_HOURS": "يقوم الفريق عادة بالرد خلال ساعات.",
        "AS_SOON_AS_THEY_CAN": "سوف يقوم الفريق بالرد عليك فى أقرب وقت ممكن.",
        "BACK_ON": "سيعود خلال",
        "BACK_IN": "سيعود فى",
        "HOURS": "ساعة | ساعات",
        "MINUTES": 'دقائق',
        provideBelowDetails: "من فضلك قم بإخال التفاصيل المطلوبة بالأسفل",
    },
    inputFields: {
        submitted: 'تم الإرسال'
    },
    inputPropDisplayNames: {
        "email": "البريد الإلكترونى",
        "phone": "رقم الهاتف",
        "Phone": "رقم الهاتف",
        "firstName": "الأسم الأول",
        "lastName": "اسم العائلة",
        "uid": "اسم المستخدم",
        "campaign": " حملة UTM",
        "medium": "UTM متوسط",
        "googleplus": "جوجل بلس",
        "shippingPhone": "رقم الهاتف الخاص بالشحن",
        "source": "UTM Source",
        "lastOrderAt": "توقيت آخر طلب",
        "firstOrderAt": "توقيت أول طلب",
        "visits": "الجلسات",
        "facebook": "فيسبوك",
        "twitter": "تويتر",
        "updatedAt": "اخر ظهور",
        "createdAt": "اول ظهور",
        "linkedin": "لينكيد إن",
        "instagram": "إنستجرام",
        "pinterest": "بنترست",
        "tumblr": "تامبلر",
        "billingEmail": "البريد الإلكترونى الخاص بالفواتير",
        "billingPhone": "رقم الهاتف الخاص بالفواتير",
        "shippingEmail": "البريد الإلكترونى الخاص بالشحن",
        "state": "المقاطعة",
        "city": "المدينة",
        "country": "الدولة",
        "deviceType": "نوع الجهاز",
        "browserName": "اسم المتصفح",
        "osName": "اسم نظام التشغيل",
        "platform": "المنصة",
        "ltv": "CLV",
        "ordersCount": "عدد الطلبات",
        "name": "الاسم",
        "RichpanelPredictedCLV": "CLV المتوقع",
        "RichpanelAliveProbability": "إحتمالية الشراء",
        "RichpanelNextOrderDate": "تاريخ الطلب التالى",
        "RichpanelPredictedOrderCount": "عدد الطلبات المتوقع",
        "aov": "AOV",
        "WebsiteURL":"رابط الموقع"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'هل انت عميل حالى؟',
        YES_EXISITING_CUSTOMER: "نعم أنا عميل حالى",
        NO_EXISITING_CUSTOMER: "لا أنا لست عميلاً حتى الأن",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "امنح الفريق طريقة للوصول إليك",
        YOU_WILL_BE_NOTIFIED_EMAIL: "سوف تتسلم إشعار هنا وعلى البريد الإلكترونى ({email}) عند قيامهم الرد.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "سوف تتسلم إشعار عند قيامهم الرد.",
        LEAVE_YOUR_MESSAGE: "من فضلك اترك رسالتك.",
        TEAM_WILL_BE_BACK_IN:"سوف يعود الفريق مرة آخرى خلال {hours} ساعة",
        TEAM_WILL_BE_BACK_ON:"سوف يعود الفريق مرة آخرى فى {availableAt}",
        FEW_MORE_DETAILS: "شكراً ! ستساعد بعض التفاصيل الإضافية في توجيهك للشخص المناسب",
    },
    initialForm: {
        heading: 'الرجاء إدخال التفاصيل الخاصة بك لبدء المحادثة',
        startChat: 'ابدأ المحادثة'
    },
    customerJourneyPreChatForm: {
        heading: 'ابدأ المحادثة',
        startChat: 'ابدأ المحادثة',
        proceed: 'تقدم',
        canWeHelpWithAnythingElse: 'هل يمكننا المساعدة فى أى أمر أخر؟',
        yes: 'نعم',
        no: 'لا',
        noThanks: "حسنا شكرا",
        yesContactSupport: "تحدث مع الدعم",
        contactSupport: "اتصل بالدعم",
    },
    rating: {
        askedHeader: 'قيم المحادثة',
        successHeader: 'لقد قمت بتقييم هذه المحادثة',
        thanksMessage: "شكراً لك لإعلامنا بذلك",
        placeholderForRatingFeedback: "من فضلك قم بكتابة مراجعة"
    },
    placeholders: {
        emojiSearch: 'ابحث الوجوه التعبيرية',
        typeAMessage: 'اكتب رسالة',
        searchGifs: 'ابحث فى الصور المتحركة',
    },
    lastMessageText: {
        sentAGif: 'ارسال صورة متحركة',
        sharedFile: 'مشاركة ملف',
        askedForQualificationDetails: 'طلب الحصول على تفاصيل مؤهلة',
        askedForRating: 'طلب الحصول على تقييم',
        askedForFeedback: 'طلب الحصول على مراجعة',
        sharedOrderSummary: "مشاركة ملخص الطلب"
    },
    greetingAnimation: {
        weAreOnline: 'نحن متواجدون الان',
        askUsAnything: 'اسألنا عن أى شىْ',
        chatWithUs: 'ابدأ محادثة معنا'
    },
    errorMessages: {
        enterEmailOrPhone:  "الرجاء إدخال البريد الإلكتروني / رقم الجوال",
        enterValidOrPhone: "أدخل بريدًا إلكترونيًا / رقم جوال صالحًا",
        userNotFound: "لم نعثر على أي مستخدم بمعرف المستخدم هذا",
        enterCode: 'الرجاء إدخال رمز تسجيل الدخول',
        invalidCode: 'أدخل'
    }
}
